// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesConfig from '../../config/services-config';

export function fetchMarkerFingerprint({echostarId, seriesId, seasonNumber, networkId}) {
    return (dispatch) => {
        const dispatchFetched = (jsonResponse) => {
            dispatch({
                type: 'FETCH_MARKER_FINGERPRINT_FULFILLED',
                data: jsonResponse,
            });
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'FETCH_MARKER_FINGERPRINT_REJECTED',
                error,
            });
        };

        const queryParams = {echostarId, seriesId, seasonNumber, networkId};

        const actionParams = {
            servicesConfig: servicesConfig.markerFingerprint,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'FETCH_MARKER_FINGERPRINT',
        });

        return actionsServiceCaller(actionParams, queryParams);
    };
}

export function resetMarkerFingerprint() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_MARKER_FINGERPRINT',
        });
    };
}
